import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './responsive-image.component.scss';
var ResponsiveImage = /** @class */ (function (_super) {
    tslib_1.__extends(ResponsiveImage, _super);
    function ResponsiveImage(element) {
        return _super.call(this, element) || this;
    }
    ResponsiveImage.prototype.init = function () {
        PictureFill();
    };
    ResponsiveImage.prototype.bindEvents = function () { };
    return ResponsiveImage;
}(Base));
export { ResponsiveImage };



//////////////////
// WEBPACK FOOTER
// ./components/responsive-image/responsive-image.component.ts
// module id = 481
// module chunks = 0